import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import store from '../store'
import componentHelper from '../js/customMdParse/componentHelper'

import routes from './routes'

Vue.use(VueRouter)

const Router = new VueRouter({
  mode: 'history',
  // base: process.env.VUE_ROUTER_BASE,
  // scrollBehavior: () => ({ y: 0 }),
  routes
})

Router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        next('/')
      } else {
        next()
      }
    })
  } else {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        if (to.path === '/') next('/home')
      } else {
        next()
      }
    })
  }
})

// Router.beforeEach((to, from, next) => {
//   // return this.$store.state.auth.currentUser
//   let currentUser = firebase.auth().currentUser
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   if (requiresAuth && !currentUser) next('/')
//   else if (!requiresAuth && currentUser && !to.matched.some(a => a.path === '/docs')) next('/home')
//   else next()
// })

Router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (store.state.ui.firestoreReady) {
      document.title = to.meta.title(to)
    }
  })
  // next((vm) => { document.title = to.meta.title(to) })
})

componentHelper.router = Router

export default Router
